import { createSelector } from "@reduxjs/toolkit";
import type { IRootState } from "../../app/store";
import {
  selectAvailableStandardRoomValidationDisciplines,
  selectStandardRoomDisciplineFromActiveRoomColoring,
} from "../../Room/roomSelectors";
import { selectHttpSingleRoomFull } from "../../Room/httpRoomSelectors";
import { formatShortDate } from "../../globalUtils";
export const selectStandardRoomPanel = createSelector(
  [
    selectAvailableStandardRoomValidationDisciplines,
    selectStandardRoomDisciplineFromActiveRoomColoring,
    (state: IRootState) => state.design.drofusStandardRoomDiscipline,
    selectHttpSingleRoomFull,
  ],
  (disciplines, fromColor, stored, room) => {
    const discipline = fromColor ?? stored?.replace(/^standardRoom\./, "") ?? disciplines[0];
    const info = discipline ? room?.validation?.standardRoom?.[discipline] : undefined;
    return {
      disciplines,
      discipline,
      disciplineOptions: disciplines.map((value) => ({ value, label: `RI${value}` })),
      matchRatePct: info?.summary?.matchRatePct,
      validatedAt: info?.validatedAt,
      validatedDate: info?.validatedAt ? formatShortDate(info.validatedAt) : undefined,
    };
  }
);
